import React, { useEffect, useState } from 'react';
import './ToolBar.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faFacebookF, faYoutube } from '@fortawesome/free-brands-svg-icons';

import { useTranslation } from 'react-i18next';

const ToolBar = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.pageYOffset < 50); // Adjust threshold as needed
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={`top-bar d-none d-md-block ${visible ? 'visible' : 'hidden'}`}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6">
                        <div className="top-bar-left">
                            {/* <div className="text">
                                <h2>9:00 - 17:00</h2>
                                <p>Opening Hours Mon - Fri | Closed on Sun & Sat</p>
                            </div>
                            <div className="text">
                                <h2>+27 83 750 7236</h2>
                                <p>Call Us For Appointment</p>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="top-bar-right">
                            <div className="social">
                                <p> {t('op.bottom-footer.links-label')}: </p>
                                <a href="https://youtu.be/i0ugHjpRKJ8?si=mF4-j3WImkc1ERbH" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                                <a href="https://www.facebook.com/share/r/36fJYutvosmasBHf/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookF} /></a>
                                <a href="https://www.linkedin.com/company/zonezapp-tech-ltd/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ToolBar;